// FollowingUserGridList.js
'use strict';
'use client';
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import UserFeedGridList from '../page/UserFeedGridList.jsx';
import withRouter from '../component/WithRouter.jsx';

import fetchFollowing from '../action/fetchFollowing.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';

const mapStateToProps = (
  state,
  {
    match: {
      params: { category },
    },
  }
) => {
  const selectPath = ['following'];

  const userIds = getListData(state, selectPath, 'itemIds');
  const nextPage = getListData(state, selectPath, 'nextPage');
  const isNextPageFetching = !!getNetworkingData(
    state,
    [...selectPath, nextPage],
    'isFetching'
  );
  const isAuthed = !!getMeData(state, 'id');

  return {
    category,
    nextPage,
    isNextPageFetching,
    userIds,
    isAuthed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    fetchFeeds: payload => dispatch(fetchFollowing(payload)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserFeedGridList)
);
